/*
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-08-28 18:15:15
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-01-25 09:26:53
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/utils/throttle.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/* 函数节流 */
export function throttle(fn, interval) {
  let enterTime = 0; // 触发的时间
  const gapTime = interval || 300; // 间隔时间，如果interval不传值，默认为300ms
  return function () {
    const that = this;
    const backTime = new Date(); // 第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.call(that, arguments);
      enterTime = backTime; // 赋值给第一次触发的时间 保存第二次触发时间
    }
  };
}

/* 函数防抖 */
let timeout = null;
export function debounce(fn, wait) {
  if (timeout !== null) clearTimeout(timeout);
  timeout = setTimeout(fn, wait);
}
